module.exports = __webpack_public_path__ + "img/developers--avatar.6a890590.svg";